var environment;
const environments = {
    devMobile: {
        TITLE: "QRSticker",
        API_HOST: "http://192.168.178.17:5005",
        DELIVERY_HOST: "https://go.dev.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.dev.qrsticker.de"
    },
    dev: {
        TITLE: "QRSticker",
        API_HOST: "http://localhost:5005",
        DELIVERY_HOST: "https://go.dev.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.dev.qrsticker.de"
    },
    stage: {
        TITLE: "QRSticker",
        API_HOST: "https://api.dev.qrsticker.de",
        DELIVERY_HOST: "https://go.dev.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.dev.qrsticker.de"
    },
    prod: {
        TITLE: "QRSticker",
        API_HOST: "https://api.qrsticker.de",
        DELIVERY_HOST: "https://go.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.qrsticker.de"
    }
}

switch (window.location.hostname)
{
    case "192.168.178.17":
        environment = environments.devMobile;
        break;
    case "localhost":
        environment = environments.dev;
        break;
    case "web.dev.qrsticker.de":
        environment = environments.stage;
        break;
    case "web.qrsticker.de":
        environment = environments.prod;
        break;
    default:
        break;
}

export default environment;
